import React, { Suspense,useRef }  from "react";
import ReactDom from "react-dom";
import HTTPRequest from "../Utils/HTTPRequest";
import CommonFunctions from "../Utils/CommonFunctions";
import Header from "./Header";
import HeaderMobile from "./HeaderMobile";
import Footer from "./Footer";
import "primeicons/primeicons.css";
import { withTranslation } from "react-i18next";
import {useParams} from "react-router-dom";
import {BrowserView, isMobile, MobileView} from 'react-device-detect';
import FooterMobile from "./FooterMobile";
import { Helmet } from 'react-helmet';

const withRouter = WrappedComponent => props => {
const params = useParams();
  
  return (
    <WrappedComponent
      params={params}
    />
  );
};
class CultureAndHeritage extends React.Component {
  constructor(props) {
    super(props);
    document.getElementById("mainloader").style.display="block";
    //ecohyperdiv
    

    this.language =CommonFunctions.getSelectedLanguage();// get the selected language
     
    this.state = {
      wpData: null,
      mapRootDiv: null,
      Title: "",
      themes: false,
      themeName: "CultureAndHeritage",
      helmetthemeName: "Culture & Heritage",
      params:this.props.params,
      images: [],
      ThemesInfo:[]
    };
    this.renderWordpressPage = this.renderWordpressPage.bind(this);
    this.renderMap = this.renderMap.bind(this);
    this.appConfig = {};

    this.onclick = this.onclick.bind(this); //scrool to the div

   //load the necessary components for culture&heritage theme
    this.UAEHealthTabsystem = CommonFunctions.lazyWithRetry(() => import("./MapComponents/Tabsystem"));
    this.attractions = CommonFunctions.lazyWithRetry(()=> import("./CultureAndHeritage/Renderwebmap2"));
  }
  render() {
    
    if (!this.state.wpData) {
      return;
    }
    document.getElementById("mainloader").style.display="none";
    return (
      <div className={this.language === "ar" ? "arabicdir" : "englishdir"}>
          {this.state.images.length!==0  && (
        <Suspense>
            <Helmet>
              <title>{this.state.helmetthemeName} - {this.language === "ar" ? this.state.Title_arabic:this.state.Title} </title>
            </Helmet>
          <BrowserView>
              <Header
                Title={this.state.Title}
                activeindex={this.state.activeindex}
                Images={this.state.images}
                ThemeName={this.state.themeName}
                ThemesInfo={this.state.ThemesInfo}
              />
          </BrowserView>
          <MobileView>
                <HeaderMobile 
                  ThemeName={this.state.themeName}
                  ThemesInfo={this.state.ThemesInfo}
                  activeindex={this.state.activeindex}
                  Images={this.state.images} ></HeaderMobile>
            </MobileView>
        </Suspense>
          )}
        <main className={this.state.themes ? "mt-5" : ""}>
          <div
            dangerouslySetInnerHTML={{
              __html: this.state.wpData.content.rendered,
            }}
          ></div>
        </main>
        <BrowserView>
            <Footer  ThemesInfo={this.state.ThemesInfo}/>
        </BrowserView>
        <MobileView>
            <FooterMobile activeclass=""></FooterMobile>
        </MobileView>
      </div>
    );
  }




  renderWordpressPage(pageId) {
    //To get the Json from word press
    let mySelf=this;
    HTTPRequest.getJson(
      `${process.env.REACT_APP_cmsRootUrl + process.env.REACT_APP_cmsPageurl}${pageId}`,
      false,
      function (response) {
        if (response == null) {
          mySelf.setState({
            wpData: {
              content: {
                rendered: "",
              },
            },
          });
          return;
        }
        mySelf.setState({ wpData: response });
        setTimeout(
          function () {
           let direction=mySelf.language=="ar"?true:false;
          let noitems=4;
          window.customcurasol(direction,noitems);
          }.bind(this),
          30
        );
      }
    );
  }

  renderMap(map) {
    let mySelf = this;
    const { t } = this.props;
    this.state.helmetthemeName=t("UAEAtlas2") + " - " + t("CultureHeritage");
    //Get the map with the name
    if (!map) {
      //TODO error reporting
      return;
    }
    //We need to wait for the div tobe loaded from wordpress cms
    let handle = window.setInterval(function () {
      let mapDiv = document.getElementById(map.mapDivId);

      if (!mapDiv) {
        return;
      }

      window.clearInterval(handle);
      //Create the map
      let MapPage = null;
      let mapName = map.name.toLowerCase();
      var iconImages=[];
      switch (mapName) {
        case "ceuaehistoricalperiods":          
        case "chmarinas": 
        case "chlandmarks":
        case "chheritagesites":
        case "chuaeattractions": 
        case "chnationallocalpartners" :
        case "chculturalfreezones":   
        {
          MapPage = mySelf.UAEHealthTabsystem;
          break;
        } 
        case "chculturaldestinations" : 
        case "archaeologocalhistory":
        case "archaeologocalheritage":
        case "archaeologocalmarinas":
        case "archaeologocallandmarks":
        case "archaeologocalattractions":{
          MapPage = mySelf.attractions; 
          break; 
        }
      }

      if (MapPage) {
        ReactDom.render(
          <React.StrictMode>
            <Suspense fallback={<div className="loader_sm"></div>}>
              {
                <MapPage
                  mapConfig={map}
                  AtlasWSurl={process.env.REACT_APP_AtlasWSurl}
                  iconImages={iconImages}
                 />
              }
            </Suspense>
          </React.StrictMode>,
          document.getElementById(map.mapDivId)
        );
      }
    }, 1000);
  }

   //scrool to the div
   onclick(event) {
    var teststr= "h-" + event.currentTarget.className;
    const section = document.getElementById( teststr );
    //section.scroll();
    section.scrollIntoView( { behavior: 'smooth', block: 'start' } );
  }
  //scrool to the div

  componentDidUpdate(prevProps) {

     //scrool to the div
     if(document.querySelectorAll(".scroll-to-")!= null)
     {
       var btn= document.querySelectorAll('[class^="scroll-to-"]');
       if(btn.length>0)
       {
         for(var i=0; i<btn.length ; i++)
         {
           btn[i].onclick =  this.onclick;
         }
       }
     }
     //scrool to the div

    if(this.props.params.source !== prevProps.params.source) {
    this.initApp1();
    }
  }
  /**
   * This method will be called only once when the component completed
   * the rendering first time
   */
  componentDidMount() {
    this.initApp1();
  }

  initApp1() {
    let that = this;
    let source = this.props.params.source;
    let theme = this.state.themeName;
    if (source != null) {
      source = source.toLowerCase();
    }
    if (theme != null) {
      theme = theme.toLowerCase();
    }
    HTTPRequest.getJson(
      process.env.REACT_APP_AtlasWSurl + "GetConfigData?theme=" + theme+"&subtheme="+ source,
      false,
      function (result) {
        if(result.SubThemesInfo.length===0)
        {
          window.location.href = process.env.REACT_APP_BASE_URL+"/404"
        }

        that.appConfig = CommonFunctions.renderAppConfig(result.SubThemesInfo,result.ThemeConfig);
       that.setState({images:CommonFunctions.renderSubThemes(result.ThemeConfig)});
       that.setState({ThemesInfo:CommonFunctions.renderThemesInfo(result.ThemesInfo)});
       sessionStorage.setItem("SubThemeInfo",JSON.stringify(CommonFunctions.renderSubThemes(result.ThemeConfig)));
        that.initApp();
      }
    );
  }
  initApp() {
    if (!this.appConfig) {
      return;
    }
    let pageId = 0;
    let source = this.props.params.source;
    let Appsettings;
    if (source != null) {
      source = source.toLowerCase();
      this.setState({ themes: true });
      Appsettings = this.appConfig[source];
    }
    pageId = Appsettings.cmsPageId;
    let Title = Appsettings.Title;
    let Title_arabic = Appsettings.Title_ar;
    let activeIndex = Appsettings.activeindex;
    //Render the word press page
    this.renderWordpressPage(pageId);
    //window.applyOnloadScripts();

    for(var i=0;i<Object.keys(Appsettings).length;i++){
      if(typeof Appsettings[Object.keys(Appsettings)[i]] === 'object' &&  Appsettings[Object.keys(Appsettings)[i]] !== null){
        this.renderMap(Appsettings[Object.keys(Appsettings)[i]]);
      }
    }
    this.setState({ Title: Title });
    this.setState({ Title_arabic: Title_arabic });
    this.setState({ activeindex: activeIndex });
  }
}
export default withRouter(withTranslation()(CultureAndHeritage));
